import { render, staticRenderFns } from "./PhotoTrapImage.vue?vue&type=template&id=1cdb5a1f&scoped=true&"
import script from "./PhotoTrapImage.vue?vue&type=script&lang=js&"
export * from "./PhotoTrapImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb5a1f",
  null
  
)

export default component.exports